// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"685":"59713360","787":"797deeef"}[chunkId] + ".chunk.js";
};